import React, { useContext } from "react";
import { Redirect, Route } from "react-router-dom";
import { LoginContext } from "./Auth/LoginContextProvider";

function PrivateRoute({
  component: Component,
  ...rest
}) {
  const { loginToken } = useContext(LoginContext);

  return (
    <Route
      {...rest}
      render={() =>
        loginToken !== null ? (
          <Component
          />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
}

export default PrivateRoute;
